import React, {ReactElement, useMemo} from "react";
import {Button, Grid, useTheme} from "@mui/material";
import {Page, PageElement, PageLayoutTemplate} from "@/smilebook-shared/types";
import {PageView} from "@/smilebook-shared/components/PageView";
import {DIVIDER} from "../../shared/dimens";

export function SidebarContentLayout(props: {
  selectedElement: PageElement,
  templates: PageLayoutTemplate[],
  selectedLayoutTemplate: string,
  setSelectedLayoutTemplate: (id: string) => void
}): ReactElement {
  const pages = useMemo<Page[]>(() => props.templates.map(template => new Page().setLayoutTemplate(template)), []);
  const theme = useTheme();
  return <Grid container spacing={2}>
    {pages.map((value, index) => <Grid item xs={6}>
      <Button
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: value.layout.id === props.selectedLayoutTemplate ? "2px solid " + theme.palette.primary.main : DIVIDER,
          padding: 0,
          background: theme.palette.background.default,
        }}
        onClick={() => {
          props.setSelectedLayoutTemplate(props.templates[index].id);
        }}>
        <div
          style={{
            width: 108,
            height: 72,
          }}>
          <PageView page={value} thumbnail={true}/>
        </div>
      </Button>
    </Grid>)}
  </Grid>;
}